import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { getImageByBreakpoint } from '@/lib/media'

export const ctaBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'

  const imageByBreakpoint = umbraco.Media?.Image ? getImageByBreakpoint(umbraco.Media.Image) : {}

  return (
    <div data-theme={theme} className='relative isolate text-[--theme-text]' style={{ backgroundColor }}>
      {/* Set to use green gradient by default and dark radial gradient if set to dark theme. The default green gradient should not show if a background colour is selected */}
      <div aria-hidden='true' className={`absolute inset-0 -z-10 transform-gpu overflow-hidden ${theme === 'dark' ? 'bg-default-800' : ''} ${theme === 'light' && umbraco.BlockBackground === '' ? 'bg-green-1' : ''}`}>
        {theme === 'dark' &&
          <div className='absolute border-radius-[800px] left-1/2 -bottom-[540px] md:-bottom-[480px] lg:-bottom-[440px] w-[1000px] h-[800px] bg-blue-rad -translate-x-1/2 blur-2xl' />}
        {umbraco.Media && umbraco.Media.Image && (
          <picture>
            {Object.keys(imageByBreakpoint).reverse().map((minWidth) => (
              <source key={minWidth} media={`(min-width: ${minWidth})`} srcSet={imageByBreakpoint[minWidth]} />
            ))}
            <img className='w-full h-full object-cover absolute inset-0 z-10' src={umbraco.Media.Image.Url} alt='' />
          </picture>
        )}
      </div>
      <div className='mx-auto w-full max-w-xl xl:max-w-7xl'>
        <div className='_block-section _ctaBlock-section px-4 py-24 sm:px-6 lg:px-8'>
          <div className='text-center'>
            <h2 className='text-balance text-4xl font-extrabold tracking-tight sm:text-5xl mb-5 last-mb-0'>
              {umbraco.Title}
            </h2>
            <div
              className='text-pretty max-w-5xl mx-auto font-semibold text-base mb-4 last-mb-0'
              dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
            />
            <div className='mt-5 flex flex-wrap items-center justify-center gap-y-2 gap-x-6'>
              {umbraco.Button && (
                <Button
                  href={umbraco.Button.Url}
                  target={umbraco.Button.Target}
                  variant='primary'
                  size='lg'
                >
                  {umbraco.Button.Name}
                </Button>
              )}
              {umbraco.ButtonText && (
                <Button
                  href={umbraco.ButtonText.Url}
                  target={umbraco.ButtonText.Target}
                  variant='link'
                >
                  {umbraco.ButtonText.Name}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const CtaBlock = ctaBlock

reactMount('ctaBlock', ctaBlock)
